<template>
	<v-container
		fluid
		class="pa-0"
	>
		<v-progress-linear
			v-if="articles.loading || previewLoading"
			indeterminate
			class="ma-0"
		/>
		<v-layout
			row
			class="output-customize"
		>
			<v-navigation-drawer
				v-if="!$vuetify.breakpoint.smAndDown"
				permanent
			>
				<v-container
					fluid
					pa-0
				>
					<v-layout
						row
						wrap
					>
						<v-flex xs12>
							<div class="title text-xs-center pa-3">
								{{ title }}
							</div>
						</v-flex>
						<v-flex
							xs12
							pb-2
							class="text-xs-center"
						>
							<v-btn
								color="primary"
								@click="save"
							>
								Save
							</v-btn>
							<v-btn
								flat
								class="red--text"
								@click="$emit('close')"
							>
								close
							</v-btn>
						</v-flex>
					</v-layout>
				</v-container>
				<v-divider/>
				<v-container>
					<v-autocomplete
						v-if="articleRelated"
						v-model="article"
						:items="articles.models"
						item-text="title"
						return-object
						persistent-hint
						label="Articles in Report"
						class="customize-autocomplete"
						hint="Select an article to use as preview."
					/>
				</v-container>
				<!-- <v-divider/>
				<v-container>
					<input v-model="markdown"
					/>
				</v-container> -->
				<!-- <v-list
					dense
					class="pt-0"
				>
					<v-list-tile
						v-for="item in articles.models"
						:key="item.id"
						:class="{ 'secondary white--text': article === item }"
						@click="article = item"
					>
						<v-list-tile-content>
							<v-list-tile-title>{{ item.title }}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list> -->
			</v-navigation-drawer>
			<MarkdownEditor
				v-model="markdown"
				:article="article"
				:report="report"
				:publications="publications.models"
				:article-related="articleRelated"
				:outputPreview="outputPreview"
				:outputKey="outputKey"
				@preview-loading="(val) => previewLoading = val"
			/>
		</v-layout>
	</v-container>
</template>

<script>
import MarkdownEditor from '@/components/MarkdownEditor';
import { Articles } from '@/models/Article';
import { ReportPublications } from '@/models/Publication';

export default {
	components: {
		MarkdownEditor,
	},
	props: {
		initialMarkdown: { type: String, default: '' },
		report: { type: Object, default: null },
		title: { type: String, default: 'Customize Output' },
		articleRelated: { type: Boolean, default: true },
		outputPreview: { type: String, default: ''},
		outputKey: { type: String, default: ''},
	},
	data() {
		return {
			articles: new Articles(),
			article: null,
			publications: new ReportPublications(),
			markdown: '',
			previewLoading: false,
		};
	},
	watch: {
		'articles.loading': {
			handler(val) {
				if (!val) {
					this.article = this.articles.models[0] || null;
				}
			},
		},
	},
	created() {
		this.markdown = this.initialMarkdown || '';
		this.articles.set('id', this.report.id);
		this.publications.set('id', this.report.id);

		this.articles.fetch({
			params: {
				isDeleted: '0',
			}
		}).then().catch(() => {
			this.$notify('error', 'Failed to get articles.');
		});

		this.publications.fetch().then().catch(() => {
			this.$notify('error', 'Failed to get publications.');
		});
	},
	methods: {
		save() {
			this.$emit('save', this.markdown);
		},
	},
};
</script>

<style lang="scss" scoped>
.output-customize {
	height: 75vh;
}
</style>
